/* ═══════════════════════════════════════════
   RARELY — Baton 4 story checkout
   The light on clean space, a Stories-style explainer that plays on
   its own (dusk to dawn), and three questions between "I'm ready"
   and checkout. ?finish=black|regal-blue|green|orange|white|fighter-pilot
   matches the hero to the ad. Everything is namespaced b4s-*.
   ═══════════════════════════════════════════ */
(function () {
  'use strict';

  var root = document.getElementById('b4s');
  var cfgEl = document.getElementById('b4s-config');
  if (!root || !cfgEl) return;

  var CFG;
  try {
    CFG = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }

  /* ── constants ── */

  var AUTO_START_MS = 3500;
  var HOLD_MS = 1100;
  var QUICK_TAP_MS = 1400;
  var LONG_PRESS_MS = 320;
  var STEP_LABELS = ['Decided', 'Finish', 'How many', 'Yours'];
  var MAX_EACH = 50;
  var ORDER = ['black', 'regal-blue', 'green', 'orange', 'white', 'fighter-pilot'];

  var CARDS = {
    what: {time: '6:47 PM', bg: '#ee9b2f', fg: '#0c0e0d', dark: false, ms: 5200},
    problem: {time: '8:12 PM', bg: '#34509e', fg: '#f1efe6', dark: true, ms: 6400},
    numbers: {time: '9:30 PM', bg: '#0f1630', fg: '#f1efe6', dark: true, ms: 6800},
    caseCard: {time: '10:15 PM', bg: '#34472f', fg: '#f1efe6', dark: true, ms: 5800},
    levels: {time: '11:40 PM', bg: '#060708', fg: '#f1efe6', dark: true, ms: 6600},
    proof: {time: '1:20 AM', bg: '#5a2a20', fg: '#f6eee2', dark: true, ms: 7600},
    price: {time: '3:05 AM', bg: '#0c0e0d', fg: '#f1efe6', dark: true, ms: 5800},
    morning: {time: '6:52 AM', bg: '#f3d6b3', fg: '#0c0e0d', dark: false, ms: 6400}
  };
  var BASE_DECK = ['what', 'problem', 'numbers', 'caseCard', 'levels', 'proof', 'price', 'morning'];
  /** Skimmers lose this one first. */
  var SKIM_DROP = 'levels';

  /** How each finish looks on the buy screens. Unknown finishes fall back to the first. */
  var LOOK = {
    black: {name: 'Black', short: 'Black', ownBg: '#131517', accent: '#ffe38a', ink: '#131517'},
    'regal-blue': {name: 'Regal Blue', short: 'Blue', ownBg: '#0e1a44', accent: '#9db8ff', ink: '#0e1a44'},
    green: {name: 'Green', short: 'Green', ownBg: '#17231a', accent: '#bcd48f', ink: '#17231a'},
    orange: {name: 'Orange', short: 'Orange', ownBg: '#3a1a08', accent: '#ff9d45', ink: '#2a1206'},
    white: {name: 'White', short: 'White', ownBg: '#25282c', accent: '#f4f3ee', ink: '#25282c'},
    'fighter-pilot': {name: 'Fighter Pilot', short: 'Pilot', ownBg: '#1d2229', accent: '#f0b54a', ink: '#1d2229'}
  };

  /** The brand's own numbers, as rarely.co states them. */
  var SPECS = [
    {n: '1,300', u: 'lm', label: 'Max output', note: 'Turbo'},
    {n: '170', u: 'm', label: 'Max throw', note: 'Nearly two football fields'},
    {n: '30', u: 'days', label: 'Max runtime', note: 'Moonlight mode'},
    {n: '5×', u: '', label: 'Full recharges', note: 'From the 5,000mAh case'}
  ];
  var LEVELS = [
    {name: 'Moon', lm: '0.5'},
    {name: 'Low', lm: '12'},
    {name: 'Medium', lm: '60'},
    {name: 'High', lm: '600'},
    {name: 'Turbo', lm: '1,300'}
  ];
  var DETAILS = [
    'Metal switch with laser-microperforated brightness and battery indicators',
    'Case button lights the flashlight in its dock; long press for stepless dimming',
    'USB-C power in and out, so the case can top up your phone',
    'Case also charges Baton 3, Perun 3 Mini, and more'
  ];
  var FACTS = '2.48\u00a0in long · USB-C in\u00a0&\u00a0out · 5\u00a0brightness\u00a0levels';
  var PROBLEMS = [
    {label: 'the breaker trips', enter: 0.3, done: 1.5},
    {label: 'keys under the seat', enter: 0.42, done: 2.0},
    {label: 'a noise behind the shed', enter: 0.54, done: 2.5},
    {label: 'phone at 9%', enter: 0.66, done: 3.0}
  ];
  var CARRY = [
    'One rides in your pocket.',
    'One lives in the truck.',
    'One goes to whoever keeps borrowing yours.'
  ];

  /* ── product ── */

  var currency = CFG.currency || 'USD';
  var money = (function () {
    try {
      var f = new Intl.NumberFormat('en-US', {style: 'currency', currency: currency});
      return function (cents) {
        return f.format((Number(cents) || 0) / 100);
      };
    } catch (e) {
      return function (cents) {
        return '$' + ((Number(cents) || 0) / 100).toFixed(2);
      };
    }
  })();

  var product = CFG.product || {variants: []};
  var finishes = (product.variants || [])
    .map(function (v) {
      var title = String(v.option1 || v.title || '');
      var slug = slugify(title);
      var look = LOOK[slug] || {
        name: title,
        short: title.split(' ')[0],
        ownBg: LOOK.black.ownBg,
        accent: LOOK.black.accent,
        ink: LOOK.black.ink
      };
      return {
        slug: slug,
        id: v.id,
        name: look.name || title,
        short: look.short,
        price: Number(v.price) || 0,
        available: Boolean(v.available),
        img: (CFG.images && CFG.images[slug]) || featuredSrc(v) || '',
        look: look
      };
    })
    .sort(function (a, b) {
      return rank(a.slug) - rank(b.slug);
    });

  var bySlug = {};
  finishes.forEach(function (f) {
    bySlug[f.slug] = f;
  });
  var avail = finishes.filter(function (f) {
    return f.available;
  });
  var soldOut = finishes.filter(function (f) {
    return !f.available;
  });
  var hasCheckout = avail.length > 0;
  var unit = finishes.length ? Math.min.apply(null, finishes.map(function (f) { return f.price; })) : 0;

  var params = new URLSearchParams(window.location.search);
  var asked = parseFinish(params);
  /** The ad's finish leads alone; otherwise the in-stock finishes stand together. */
  var heroSet = asked && bySlug[asked] ? [bySlug[asked]] : (avail.length ? avail : finishes).slice(0, 3);
  var heroOne = heroSet[0] || null;
  var defaultPick = asked && bySlug[asked] && bySlug[asked].available ? asked : avail[0] ? avail[0].slug : heroOne ? heroOne.slug : '';
  var fromLine = unit ? 'From ' + money(unit) + ' · charging case included' : '';

  /* ── state ── */

  var S = {
    screen: 'fork',
    autoDone: false,
    story: freshStory(),
    holdPaused: false,
    hidden: false,
    sheetOpen: false,
    sheetFinish: heroOne ? heroOne.slug : '',
    step: 1,
    pick: defaultPick,
    /** How many of each finish are in the set, keyed by finish. */
    counts: freshCounts(defaultPick),
    /** True once they change a count, so a new finish pick keeps their set. */
    touched: false,
    holding: false,
    sending: false,
    uncertain: false,
    error: null,
    readyHref: null
  };
  var cardStartedAt = 0;
  var downAt = 0;
  var lastPress = 0;
  var forkY = null;
  var sheetReturn = null;
  var hydrated = false;

  /* ═══════════════════════════════════════════
     RENDER
     ═══════════════════════════════════════════ */

  function paint() {
    var bg = '#e8e6dc';
    var fg = '#0c0e0d';
    if (S.screen === 'story') {
      var c = CARDS[currentCard()];
      if (c) {
        bg = c.bg;
        fg = c.fg;
      }
    } else if (S.screen === 'own') {
      var f = bySlug[S.pick];
      bg = f ? f.look.ownBg : '#131517';
      fg = '#f1efe6';
    }
    root.style.backgroundColor = bg;
    root.style.color = fg;
  }

  function render() {
    var sheet = S.sheetOpen ? root.querySelector('.b4s-sheet-wrap') : null;
    if (S.screen === 'fork' || S.screen === 'end') root.innerHTML = forkHtml();
    else if (S.screen === 'story') root.innerHTML = storyHtml();
    else root.innerHTML = ownHtml();
    if (sheet) root.appendChild(sheet);
    paint();
    wire();
  }

  /* ── the light on clean space ── */

  function forkHtml() {
    var end = S.screen === 'end';
    var autoOn = !end && !S.autoDone;
    var h = '';
    h += '<div class="b4s-fork" data-zone="fork">';
    h += '<div class="b4s-brand b4s-mono">Rarely · Olight Baton 4 Premium Edition</div>';
    h += '<div class="b4s-hero-col">';
    h += heroGroupHtml(heroSet);
    h += '<div class="b4s-shadow" style="--n:' + heroSet.length + '" aria-hidden="true"></div>';
    h += '<button type="button" class="b4s-link b4s-mono" data-action="specs" data-finish="' + attr(heroOne ? heroOne.slug : '') + '">Specs &amp; what’s in the box</button>';
    h += '</div>';
    h += '<div class="b4s-learn-col">';
    if (!end) {
      h += '<button type="button" class="b4s-learn-btn" data-action="learn">';
      h += '<span class="b4s-d b4s-learn-big">' + icon('chevL', 30, 1.8) + '<span class="b4s-display">Learn more</span></span>';
      h += '<span class="b4s-p b4s-learn-small">' + icon('up', 18, 2, 'b4s-nudge') + 'Learn more</span>';
      h += '</button>';
      if (autoOn) {
        h += '<div class="b4s-auto" aria-hidden="true">';
        // The countdown starts once the script can react to it.
        if (hydrated) h += '<span class="b4s-auto-fill" style="--b4s-dur:' + AUTO_START_MS + 'ms"></span>';
        h += '</div>';
      }
    } else {
      h += '<div class="b4s-end-copy">';
      h += '<span class="b4s-display b4s-in">That’s the whole pitch.</span>';
      h += '<button type="button" class="b4s-ghost" data-action="replay">' + icon('replay', 18) + 'Watch it again</button>';
      h += '</div>';
    }
    h += '</div>';
    h += '<div class="b4s-ready-col">';
    h += readyHtml(false, false);
    if (fromLine) h += '<span class="b4s-mono b4s-subtle">' + esc(fromLine) + '</span>';
    h += '</div>';
    h += '</div>';
    return h;
  }

  function heroGroupHtml(set) {
    var h = '<div class="b4s-group" style="--n:' + set.length + '">';
    set.forEach(function (f, i) {
      h += '<div class="b4s-float" style="--i:' + i + '">';
      h += lampHtml(f, {cls: 'b4s-hero-lamp', glint: true, sheen: true, alt: altFor(f)});
      h += '</div>';
    });
    return h + '</div>';
  }

  /** A docked Baton 4. The beam (optional) starts at the lens and rides any rotation. */
  function lampHtml(f, o) {
    o = o || {};
    if (!f) return '';
    var h = '<span class="b4s-lamp ' + (o.cls || '') + '"' + (o.style ? ' style="' + o.style + '"' : '') + '>';
    if (o.beam) h += '<span class="b4s-beam ' + (o.beam === true ? '' : o.beam) + '" aria-hidden="true"></span>';
    h += '<img src="' + attr(f.img) + '" width="366" height="682" alt="' + attr(o.alt || '') + '" draggable="false">';
    if (o.sheen) h += '<span class="b4s-sheen" aria-hidden="true" style="-webkit-mask-image:url(' + cssUrl(f.img) + ');mask-image:url(' + cssUrl(f.img) + ')"></span>';
    if (o.glint) h += '<span class="b4s-glint" aria-hidden="true"></span>';
    return h + '</span>';
  }

  function readyHtml(full, light) {
    var cls = 'b4s-ready' + (light ? ' is-light' : '') + (full ? ' is-full' : '');
    if (!hasCheckout && CFG.shopHref) {
      return '<button type="button" class="' + cls + '" data-action="restock">Get a restock alert' + icon('right', 20) + '</button>';
    }
    return '<button type="button" class="' + cls + '" data-action="ready">I’m ready to own this' + icon('right', 20) + '</button>';
  }

  /* ── the story ── */

  function currentCard() {
    return S.story.deck[S.story.idx] || null;
  }

  function storyHtml() {
    var id = currentCard();
    var card = CARDS[id];
    var h = '';
    h += '<div class="b4s-story">';
    h += '<div class="b4s-d b4s-story-left"><button type="button" class="b4s-ghost" data-action="fork">' + icon('left', 20) + 'Back to the light</button></div>';
    h += '<div class="b4s-story-main' + (isPaused() ? ' is-paused' : '') + '">';
    h += '<div class="b4s-chrome b4s-segs" aria-hidden="true">' + segsHtml() + '</div>';
    h += '<div class="b4s-chrome b4s-meta"><span class="b4s-mono b4s-clock">' + esc(card.time) + (S.holdPaused ? ' · paused' : '') + '</span>';
    h += '<div class="b4s-p"><button type="button" class="b4s-icon" aria-label="Close and go back to the light" data-action="fork">' + icon('close', 22) + '</button></div></div>';
    h += '<div class="b4s-card-area b4s-noselect" aria-live="polite">';
    h += cardHtml(id);
    h += '<button type="button" class="b4s-tap b4s-tap-prev" aria-label="Previous"></button>';
    h += '<button type="button" class="b4s-tap b4s-tap-next" aria-label="Next"></button>';
    h += '</div>';
    h += '<div class="b4s-p b4s-story-cta">' + readyHtml(true, card.dark) + '</div>';
    h += '</div>';
    h += '<div class="b4s-d b4s-story-right">' + readyHtml(false, card.dark);
    if (fromLine) h += '<span class="b4s-mono b4s-from">' + esc(fromLine) + '</span>';
    h += '</div>';
    h += '</div>';
    return h;
  }

  function segsHtml() {
    var id = currentCard();
    var dark = CARDS[id] && CARDS[id].dark;
    var track = dark ? 'rgba(241,239,230,0.28)' : 'rgba(12,14,13,0.2)';
    var h = '';
    S.story.deck.forEach(function (cid, i) {
      h += '<span class="b4s-seg" style="background:' + track + '">';
      if (i < S.story.idx) h += '<span class="b4s-seg-fill is-done"></span>';
      if (i === S.story.idx) h += '<span class="b4s-seg-fill is-run" style="--b4s-dur:' + durOf(cid) + 'ms"></span>';
      h += '</span>';
    });
    return h;
  }

  function cardHtml(id) {
    var lead = heroOne;
    var h = '';
    if (id === 'what') {
      h += '<div class="b4s-card b4s-card-what">';
      h += '<h2 class="b4s-display b4s-in b4s-h-xl b4s-rel">This is pocket daylight.</h2>';
      h += '<p class="b4s-in b4s-body b4s-rel" style="margin-top:14px;max-width:22ch;animation-delay:.45s">1,300 lumens, shorter than your index finger.</p>';
      h += '<div class="b4s-what-art">' + lampHtml(lead, {cls: 'b4s-card-lamp', beam: 'is-on', glint: true, alt: lead ? 'Baton 4 in ' + lead.name + ', docked in its open charging case' : ''}) + '</div>';
      h += '<span class="b4s-mono b4s-hint-fade">Tap to skip · Hold to pause</span>';
      h += '</div>';
    }
    if (id === 'problem') {
      h += '<div class="b4s-card">';
      h += '<h2 class="b4s-display b4s-in b4s-h-lg" style="max-width:9ch">Your phone has one job.</h2>';
      h += '<div class="b4s-probs">';
      PROBLEMS.forEach(function (p) {
        h += '<div class="b4s-prob" style="animation-delay:' + p.enter + 's,' + p.done + 's">';
        h += '<span class="b4s-prob-dot"></span><span class="b4s-prob-t">' + esc(p.label) + '</span>';
        h += '<span class="b4s-prob-ok" style="animation-delay:' + p.done + 's">' + icon('check', 16, 3) + '</span>';
        h += '<span class="b4s-prob-strike" style="animation-delay:' + p.done + 's"></span>';
        h += '</div>';
      });
      h += '</div>';
      h += '<p class="b4s-in b4s-body" style="margin-top:22px;animation-delay:3.5s">Don’t make it the flashlight. One click handles all four.</p>';
      h += '</div>';
    }
    if (id === 'numbers') {
      h += '<div class="b4s-card">';
      h += '<span class="b4s-mono b4s-in b4s-eyebrow">The numbers</span>';
      h += '<div class="b4s-stats">';
      SPECS.forEach(function (s, i) {
        var d = 'animation-delay:' + (0.25 + i * 0.18) + 's';
        h += '<div class="b4s-stat">';
        h += '<span class="b4s-display b4s-in b4s-stat-n' + (i === 0 ? ' is-beam' : '') + '" style="' + d + '">' + esc(s.n) + (s.u ? '<span class="b4s-stat-u">' + esc(s.u) + '</span>' : '') + '</span>';
        h += '<span class="b4s-in b4s-stat-l" style="' + d + '">' + esc(s.label) + '<span class="b4s-mono">' + esc(s.note) + '</span></span>';
        h += '</div>';
      });
      h += '</div>';
      h += '<div class="b4s-card-cta b4s-in" style="animation-delay:1.3s"><button type="button" class="b4s-pill-btn" data-action="specs" data-finish="' + attr(lead ? lead.slug : '') + '">See all the specs</button></div>';
      h += '</div>';
    }
    if (id === 'caseCard') {
      h += '<div class="b4s-card is-centered">';
      h += '<span class="b4s-mono b4s-in b4s-eyebrow">The case is the other half</span>';
      h += '<div class="b4s-words">';
      h += '<span class="b4s-display b4s-in" style="animation-delay:.25s">Charger.</span>';
      h += '<span class="b4s-display b4s-in" style="animation-delay:.95s">Power bank.</span>';
      h += '<span class="b4s-display b4s-in is-beam" style="animation-delay:1.65s">Control deck.</span>';
      h += '</div>';
      h += '<div class="b4s-pips" aria-hidden="true">';
      for (var p = 0; p < 5; p++) h += '<span class="b4s-pip" style="animation-delay:' + (2.2 + p * 0.38) + 's"></span>';
      h += '<span class="b4s-mono b4s-pips-l b4s-in" style="animation-delay:4.1s">5 full recharges</span>';
      h += '</div>';
      h += '<p class="b4s-in b4s-body" style="margin-top:18px;max-width:26ch;animation-delay:2.5s">It tops up your phone, and its button lights the Baton right in the dock.</p>';
      h += '</div>';
    }
    if (id === 'levels') {
      h += '<div class="b4s-card b4s-card-levels">';
      h += '<h2 class="b4s-display b4s-in b4s-h-md b4s-rel" style="max-width:12ch">From “don’t wake them” to “what was that?”</h2>';
      h += '<div class="b4s-levels-stage">';
      h += '<ol class="b4s-lvls" aria-label="Five brightness levels">';
      LEVELS.forEach(function (l, i) {
        var last = i === LEVELS.length - 1;
        var on = 0.5 + i * 0.95;
        h += '<li class="b4s-lvl' + (last ? ' is-last' : '') + '" style="animation-delay:' + on + 's' + (last ? '' : ',' + (on + 0.95) + 's') + '">';
        h += '<span class="b4s-mono">' + esc(l.name) + '</span><span class="b4s-display">' + esc(l.lm) + '<small>lm</small></span></li>';
      });
      h += '</ol>';
      h += '<div class="b4s-levels-art">' + lampHtml(lead, {cls: 'b4s-lvl-lamp', beam: 'is-ramp', alt: ''}) + '</div>';
      h += '</div>';
      h += '</div>';
    }
    if (id === 'proof') {
      var trio = (avail.length >= 3 ? avail : finishes).slice(0, 3);
      h += '<div class="b4s-card is-centered">';
      h += '<span class="b4s-mono b4s-in b4s-eyebrow">Ready for everyday</span>';
      h += '<h2 class="b4s-display b4s-in b4s-h-md" style="margin-top:12px;max-width:13ch;animation-delay:.25s">One for your pocket. One for the truck.</h2>';
      h += '<div class="b4s-carry">';
      CARRY.forEach(function (line, i) {
        var f = trio[i % Math.max(1, trio.length)];
        h += '<div class="b4s-carry-row b4s-pop-in" style="animation-delay:' + (1.4 + i * 1.3) + 's">';
        if (f) h += '<img src="' + attr(f.img) + '" width="366" height="682" alt="">';
        h += '<span>' + esc(line) + '</span></div>';
      });
      h += '</div>';
      h += '</div>';
    }
    if (id === 'price') {
      h += '<div class="b4s-card">';
      h += '<div class="b4s-layer" aria-hidden="true">' + starsHtml() + '</div>';
      h += '<div class="b4s-rel b4s-price-wrap">';
      if (S.story.fast) h += '<span class="b4s-mono b4s-in b4s-eyebrow is-beam" style="margin-bottom:14px">Skimming? Fair. The short version:</span>';
      if (unit) {
        h += '<h2 class="b4s-display b4s-in b4s-price-big">' + esc(money(unit)) + ' <span>case included.</span></h2>';
        h += '<h3 class="b4s-display b4s-in b4s-price-sub" style="animation-delay:.5s">Ready when you need it.</h3>';
        h += '<p class="b4s-in b4s-body" style="margin-top:20px;animation-delay:1s">Shipping and taxes are calculated at checkout.</p>';
      } else {
        h += '<h2 class="b4s-display b4s-in b4s-h-lg">Today’s price is one tap away.</h2>';
      }
      h += '</div>';
      h += '</div>';
    }
    if (id === 'morning') {
      h += '<div class="b4s-card">';
      h += '<div class="b4s-dawn" aria-hidden="true"></div><div class="b4s-sun" aria-hidden="true"></div>';
      h += '<span class="b4s-mono b4s-in b4s-eyebrow b4s-rel">The next morning</span>';
      h += '<h2 class="b4s-display b4s-in b4s-h-lg b4s-rel" style="margin-top:12px;max-width:10ch;animation-delay:.25s">Tonight’s already handled.</h2>';
      h += '<p class="b4s-in b4s-body b4s-rel" style="margin-top:16px;max-width:24ch;animation-delay:.9s">Full from its case, back in your pocket, ready before the dark is.</p>';
      h += '<figure class="b4s-in b4s-morning-quote b4s-rel" style="animation-delay:1.9s"><blockquote>“Prepared” is just a future problem that already has an answer.</blockquote><figcaption class="b4s-mono">Rarely</figcaption></figure>';
      h += '</div>';
    }
    return h;
  }

  var STARS = (function () {
    var out = [];
    for (var i = 0; i < 30; i++) {
      out.push({
        top: (seeded(i, 1) * 100).toFixed(1) + '%',
        left: (seeded(i, 2) * 100).toFixed(1) + '%',
        size: (1.3 + seeded(i, 3) * 2.2).toFixed(1) + 'px',
        dur: (2.2 + seeded(i, 4) * 3).toFixed(2) + 's',
        delay: (-seeded(i, 5) * 4).toFixed(2) + 's'
      });
    }
    return out;
  })();
  function starsHtml() {
    return STARS.map(function (s) {
      return '<span class="b4s-star" style="top:' + s.top + ';left:' + s.left + ';width:' + s.size + ';height:' + s.size + ';animation-duration:' + s.dur + ';animation-delay:' + s.delay + '"></span>';
    }).join('');
  }

  /* ── owning it ── */

  function ownHtml() {
    var h = '';
    h += '<div class="b4s-own-wrap">';
    h += '<div class="b4s-d b4s-own-art" data-slot="art">' + ownArtHtml() + '</div>';
    h += '<div class="b4s-own">';
    h += '<div class="b4s-own-top">';
    h += '<button type="button" class="b4s-icon" aria-label="Back" data-action="own-back">' + icon('left', 22) + '</button>';
    h += '<div class="b4s-progress"><div class="b4s-progress-track"><div class="b4s-progress-fill" data-slot="fill" style="width:' + S.step * 25 + '%"></div></div>';
    h += '<div class="b4s-steps">';
    STEP_LABELS.forEach(function (l, i) {
      h += '<span class="b4s-mono b4s-step-label" style="opacity:' + (i <= S.step ? 1 : 0.62) + '">' + (i < S.step ? icon('check', 12, 3) : '') + esc(l) + '</span>';
    });
    h += '</div></div>';
    h += '</div>';
    h += '<div class="b4s-own-body">' + stepHtml() + '</div>';
    h += '<div class="b4s-own-foot" data-slot="foot">' + footHtml() + '</div>';
    h += '</div>';
    h += '</div>';
    return h;
  }

  /** The set as rows, in display order: [{f, n}]. */
  function setRows() {
    return avail
      .filter(function (f) { return (S.counts[f.slug] || 0) > 0; })
      .map(function (f) { return {f: f, n: S.counts[f.slug]}; });
  }
  function setTotal() {
    return setRows().reduce(function (sum, r) { return sum + r.n; }, 0);
  }
  function setPrice() {
    return setRows().reduce(function (sum, r) { return sum + r.n * r.f.price; }, 0);
  }
  /** Distinct finishes to draw, at most four. */
  function setArt() {
    var rows = setRows().map(function (r) { return r.f; });
    if (!rows.length && bySlug[S.pick]) rows = [bySlug[S.pick]];
    return rows.slice(0, 4);
  }

  function ownArtHtml() {
    var list = setArt();
    var total = setTotal();
    var h = '<div class="b4s-own-group" style="--n:' + list.length + '">';
    list.forEach(function (f, i) {
      h += '<div class="b4s-float" style="--i:' + i + '">' + lampHtml(f, {cls: 'b4s-own-lamp', alt: 'Baton 4 in ' + f.name}) + '</div>';
    });
    h += '</div>';
    if (total > 1) h += '<span class="b4s-display b4s-own-count" aria-hidden="true">×' + total + '</span>';
    return h;
  }

  function stepHtml() {
    var h = '';
    if (S.step === 1) {
      var cols = avail.length >= 3 ? 3 : Math.max(1, avail.length);
      h += '<div class="b4s-step">';
      h += '<h2 class="b4s-display b4s-in b4s-q">Which one’s yours?</h2>';
      h += '<div class="b4s-fins b4s-in" style="--cols:' + cols + ';animation-delay:.15s" role="group" aria-label="Finish">';
      avail.forEach(function (f) {
        h += '<button type="button" class="b4s-fin" data-action="pick" data-finish="' + attr(f.slug) + '" aria-pressed="' + (S.pick === f.slug) + '">';
        h += '<img src="' + attr(f.img) + '" width="366" height="682" alt="">';
        h += '<span class="b4s-fin-name">' + esc(f.name) + '</span>';
        h += '</button>';
      });
      h += '</div>';
      h += '<div class="b4s-fin-meta"><span class="b4s-mono b4s-fin-note">Each comes with its own charging case</span>';
      h += '<button type="button" class="b4s-link b4s-mono" data-action="specs" data-finish="' + attr(S.pick) + '">Specs</button></div>';
      if (soldOut.length) {
        var askedOut = asked && bySlug[asked] && !bySlug[asked].available ? bySlug[asked] : null;
        var others = soldOut.filter(function (f) { return f !== askedOut; }).map(function (f) { return f.name; });
        var note = askedOut
          ? askedOut.name + ' is sold out right now.' + (others.length ? ' So ' + (others.length > 1 ? 'are ' : 'is ') + andList(others) + '.' : '')
          : 'Sold out right now: ' + andList(others) + '.';
        h += '<p class="b4s-sold b4s-in" style="animation-delay:.3s">' + esc(note);
        if (CFG.restockHref) h += ' <button class="b4s-inline-link" data-action="restock" type="button">Get a restock note</button>';
        h += '</p>';
      }
      h += '</div>';
    }
    if (S.step === 2) {
      h += '<div class="b4s-step">';
      h += '<h2 class="b4s-display b4s-in b4s-q">How many?</h2>';
      h += '<div class="b4s-set b4s-in' + (avail.length > 3 ? ' is-compact' : '') + '" style="animation-delay:.15s" role="group" aria-label="Lights in your set">';
      avail.forEach(function (f) {
        var n = S.counts[f.slug] || 0;
        h += '<div class="b4s-set-row' + (n > 0 ? ' is-on' : '') + '" data-row="' + attr(f.slug) + '">';
        h += '<img src="' + attr(f.img) + '" width="366" height="682" alt="">';
        h += '<span class="b4s-set-name">' + esc(f.name) + '<span class="b4s-mono">' + esc(money(f.price)) + '</span></span>';
        h += '<span class="b4s-step-ctl">';
        h += '<button type="button" class="b4s-step-btn" data-action="dec" data-finish="' + attr(f.slug) + '" aria-label="One less ' + attr(f.name) + '"' + (n <= 0 ? ' disabled' : '') + '>' + icon('minus', 18, 2.4) + '</button>';
        h += '<input class="b4s-display b4s-count" id="b4s-count-' + attr(f.slug) + '" data-finish="' + attr(f.slug) + '" type="text" inputmode="numeric" pattern="[0-9]*" autocomplete="off" value="' + n + '" aria-label="' + attr(f.name) + ' quantity">';
        h += '<button type="button" class="b4s-step-btn" data-action="inc" data-finish="' + attr(f.slug) + '" aria-label="One more ' + attr(f.name) + '"' + (n >= MAX_EACH ? ' disabled' : '') + '>' + icon('plus', 18, 2.4) + '</button>';
        h += '</span>';
        h += '</div>';
      });
      h += '</div>';
      h += '</div>';
    }
    if (S.step === 3) {
      var art = setArt();
      h += '<div class="b4s-step">';
      h += '<h2 class="b4s-display b4s-in b4s-q">Make it yours.</h2>';
      h += '<div class="b4s-p b4s-sum-art b4s-in" style="animation-delay:.1s">' + art.map(function (f) {
        return '<img src="' + attr(f.img) + '" width="366" height="682" alt="">';
      }).join('') + (setTotal() > 1 ? '<span class="b4s-display b4s-sum-count">×' + setTotal() + '</span>' : '') + '</div>';
      h += '<p class="b4s-in b4s-summary" style="animation-delay:.15s">' + esc(summary()) + '</p>';
      h += '<p class="b4s-in b4s-mono b4s-summary-note" style="animation-delay:.25s">' + esc('Charging case with each · Shipping calculated at checkout') + '</p>';
      h += '</div>';
    }
    return h;
  }

  function totalHtml() {
    var n = setTotal();
    if (!n) return '<span>Add at least one light.</span>';
    var ship = '<span class="b4s-ship">Shipping calculated at checkout</span>';
    return '<span class="b4s-set-sum"><span class="b4s-display">' + n + (n === 1 ? ' light' : ' lights') + '</span><span class="b4s-display">' + esc(money(setPrice())) + '</span></span>' + ship;
  }

  function footHtml() {
    var look = bySlug[S.pick] ? bySlug[S.pick].look : LOOK.black;
    if (S.uncertain) return '<p class="b4s-error" role="alert">Your cart may have been updated. Review it before adding again.</p><a class="b4s-ready is-light is-full" href="/cart">Review your cart</a><button class="b4s-hold" disabled>Check cart first</button>';
    if (S.step < 3) {
      var n = setTotal();
      var label = S.step === 1 ? (bySlug[S.pick] ? bySlug[S.pick].name + ' it is' : 'Next') : n === 1 ? 'Just the one' : n ? countWord(n) + ' it is' : 'Add at least one';
      var off = S.step === 2 && !n;
      // The running total sits with the button so it never scrolls away.
      var total = S.step === 2 ? '<p class="b4s-set-total" aria-live="polite">' + totalHtml() + '</p>' : '';
      return total + '<button type="button" class="b4s-ready is-light is-full" data-action="own-next"' + (off ? ' disabled' : '') + '>' + esc(label) + icon('right', 20) + '</button>';
    }
    if (S.readyHref) {
      return '<div class="b4s-hold-wrap"><a class="b4s-ready is-light is-full" href="' + attr(S.readyHref) + '" target="_blank" rel="noopener">Open checkout on rarely.co' + icon('out', 20) + '</a>' +
        '<p class="b4s-mono b4s-hold-note">Preview only. On rarely.co the hold goes straight to checkout.</p></div>';
    }
    var lbl = S.sending ? 'Opening checkout…' : S.holding ? 'Keep holding' : 'Hold to make it yours';
    var h = '<div class="b4s-hold-wrap">';
    h += '<button type="button" class="b4s-hold b4s-noselect' + (S.holding ? ' is-holding' : '') + (S.sending ? ' is-sending' : '') + '" aria-label="Hold to make it yours"' + (S.sending || !hasCheckout || !setTotal() ? ' disabled' : '') + '>';
    h += '<span class="b4s-hold-lbl">' + esc(lbl) + '</span>';
    h += '<span class="b4s-hold-lbl b4s-hold-top" aria-hidden="true" style="background-color:' + look.accent + ';color:' + look.ink + ';--b4s-hold:' + HOLD_MS + 'ms">' + esc(lbl) + '</span>';
    h += '</button>';
    if (S.error) h += '<p class="b4s-error" role="alert">' + esc(S.error) + '</p>';
    return h + '</div>';
  }

  /** Updates choices in place so the entrance animations don't replay. */
  function syncOwn() {
    if (S.screen !== 'own') return;
    paint();
    var look = bySlug[S.pick] ? bySlug[S.pick].look : LOOK.black;
    var fill = root.querySelector('[data-slot="fill"]');
    if (fill) fill.style.backgroundColor = look.accent;
    root.style.setProperty('--b4s-accent', look.accent);
    root.querySelectorAll('.b4s-fin').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-finish') === S.pick));
    });
    root.querySelectorAll('.b4s-set-row').forEach(function (row) {
      var slug = row.getAttribute('data-row');
      var n = S.counts[slug] || 0;
      row.classList.toggle('is-on', n > 0);
      var input = row.querySelector('.b4s-count');
      // Leave the field alone while they're typing in it.
      if (input && document.activeElement !== input) input.value = String(n);
      var dec = row.querySelector('[data-action="dec"]');
      var inc = row.querySelector('[data-action="inc"]');
      if (dec) dec.disabled = n <= 0;
      if (inc) inc.disabled = n >= MAX_EACH;
    });
    var art = root.querySelector('[data-slot="art"]');
    if (art) {
      var key = setArt().map(function (f) { return f.slug; }).join('+') + ':' + setTotal();
      if (art.getAttribute('data-key') !== key) {
        art.setAttribute('data-key', key);
        art.innerHTML = ownArtHtml();
      }
    }
    var foot = root.querySelector('[data-slot="foot"]');
    if (foot) {
      foot.innerHTML = footHtml();
      wireHold();
    }
  }

  function setCount(slug, n) {
    if (S.sending || S.uncertain) return;
    if (!bySlug[slug] || !bySlug[slug].available) return;
    n = Math.max(0, Math.min(MAX_EACH, Math.floor(Number(n) || 0)));
    S.counts[slug] = n;
    S.touched = true;
    S.error = null;
    syncOwn();
  }

  /* ── specs sheet ── */

  function sheetHtml() {
    var f = bySlug[S.sheetFinish] || heroOne;
    var h = '';
    h += '<button type="button" class="b4s-sheet-backdrop" aria-label="Close specs" tabindex="-1" data-action="sheet-close"></button>';
    h += '<div class="b4s-sheet" role="dialog" aria-modal="true" aria-labelledby="b4s-sheet-title">';
    h += '<div class="b4s-sheet-head"><h2 id="b4s-sheet-title" class="b4s-display b4s-sheet-title">The specs</h2>';
    h += '<button type="button" class="b4s-icon" aria-label="Close" data-action="sheet-close">' + icon('close', 22) + '</button></div>';
    h += '<div class="b4s-sheet-fins" role="group" aria-label="Finish">';
    finishes.forEach(function (x) {
      h += '<button type="button" class="b4s-sheet-chip" data-action="sheet-finish" data-finish="' + attr(x.slug) + '" aria-pressed="' + (f && x.slug === f.slug) + '">' + esc(x.short) + '</button>';
    });
    h += '</div>';
    if (f) {
      h += '<div class="b4s-sheet-pick"><img src="' + attr(f.img) + '" width="366" height="682" alt="Baton 4 in ' + attr(f.name) + '">';
      h += '<span><span class="b4s-sheet-name">Baton 4 · ' + esc(f.name) + '</span>';
      h += '<span class="b4s-mono b4s-stock' + (f.available ? ' is-in' : '') + '">' + (f.available ? 'In stock · ' + esc(money(f.price)) : 'Sold out') + '</span></span></div>';
    }
    h += '<ul class="b4s-keys">';
    SPECS.forEach(function (s) {
      h += '<li class="b4s-key"><span class="b4s-display b4s-key-n">' + esc(s.n) + (s.u ? '<span class="b4s-stat-u">' + esc(s.u) + '</span>' : '') + '</span>';
      h += '<span><span class="b4s-key-name">' + esc(s.label) + '</span><span class="b4s-mono b4s-key-note">' + esc(s.note) + '</span></span></li>';
    });
    h += '</ul>';
    h += '<p class="b4s-mono b4s-facts">' + esc(FACTS) + '</p>';
    h += '<h3 class="b4s-mono b4s-sheet-label">Five levels</h3>';
    h += '<p class="b4s-sheet-list">' + LEVELS.slice().reverse().map(function (l) { return esc(l.name) + ' ' + esc(l.lm) + '\u00a0lm'; }).join(' · ') + '</p>';
    h += '<h3 class="b4s-mono b4s-sheet-label">In the box' + (f ? ', ' + esc(f.name) : '') + '</h3>';
    h += '<p class="b4s-sheet-list">The Baton 4 flashlight' + (f ? ' in ' + esc(f.name) : '') + ' and its 5,000mAh charging case.</p>';
    h += '<h3 class="b4s-mono b4s-sheet-label">Details</h3>';
    h += '<ul class="b4s-sheet-ul">' + DETAILS.map(function (d) { return '<li>' + esc(d) + '</li>'; }).join('') + '</ul>';
    h += '<p class="b4s-sheet-fine">1,300 lumens is Turbo, the brightest level; 30 days is Moonlight, the lowest. Shipping calculated at checkout. Olight Baton 4 Premium Edition, sold by Rarely.</p>';
    h += '</div>';
    return h;
  }

  function openSheet(slug) {
    sheetReturn = document.activeElement;
    S.sheetFinish = bySlug[slug] ? slug : heroOne ? heroOne.slug : '';
    S.sheetOpen = true;
    var wrap = document.createElement('div');
    wrap.className = 'b4s-sheet-wrap';
    wrap.innerHTML = sheetHtml();
    root.appendChild(wrap);
    syncPause();
    var close = wrap.querySelector('.b4s-sheet .b4s-icon');
    if (close) close.focus();
    track('b4s_specs', {finish: S.sheetFinish, screen: S.screen});
  }

  function refreshSheet() {
    var wrap = root.querySelector('.b4s-sheet-wrap');
    if (!wrap) return;
    var scroll = wrap.querySelector('.b4s-sheet');
    var top = scroll ? scroll.scrollTop : 0;
    wrap.innerHTML = sheetHtml();
    var again = wrap.querySelector('.b4s-sheet');
    if (again) {
      again.scrollTop = top;
      again.classList.add('is-static');
    }
    var chip = wrap.querySelector('.b4s-sheet-chip[aria-pressed="true"]');
    if (chip) chip.focus();
  }

  function closeSheet() {
    var wrap = root.querySelector('.b4s-sheet-wrap');
    if (wrap) wrap.remove();
    S.sheetOpen = false;
    syncPause();
    var back = sheetReturn;
    window.setTimeout(function () {
      if (back && document.contains(back) && back.focus) back.focus();
    }, 0);
  }

  /* ═══════════════════════════════════════════
     BEHAVIOR
     ═══════════════════════════════════════════ */

  function isPaused() {
    return S.holdPaused || S.hidden || S.sheetOpen;
  }

  /** Pausing only flips classes, so running timers keep their place. */
  function syncPause() {
    var main = root.querySelector('.b4s-story-main');
    if (main) main.classList.toggle('is-paused', isPaused());
    var clock = root.querySelector('.b4s-clock');
    var card = CARDS[currentCard()];
    if (clock && card) clock.textContent = card.time + (S.holdPaused ? ' · paused' : '');
    var auto = root.querySelector('.b4s-auto-fill');
    if (auto) auto.style.animationPlayState = S.hidden || S.sheetOpen ? 'paused' : 'running';
  }

  function freshStory() {
    return {deck: BASE_DECK.slice(), idx: 0, nonce: 0, fast: false, quick: 0, seen: 1};
  }

  function durOf(id) {
    return S.story.fast ? Math.round(CARDS[id].ms * 0.7) : CARDS[id].ms;
  }

  function startStory(trigger) {
    S.autoDone = true;
    S.story = freshStory();
    S.holdPaused = false;
    S.screen = 'story';
    cardStartedAt = Date.now();
    render();
    track('b4s_story_start', {trigger: trigger}, true);
    trackCard();
  }

  function next(auto) {
    var st = S.story;
    var deck = st.deck;
    var fast = st.fast;
    var quick = 0;
    if (!auto) {
      quick = Date.now() - cardStartedAt < QUICK_TAP_MS ? st.quick + 1 : 0;
      if (quick >= 2 && !fast) {
        // Skimmers get the short version.
        fast = true;
        deck = deck.filter(function (id, i) {
          return i <= st.idx || id !== SKIM_DROP;
        });
      }
    }
    var nextIdx = st.idx + 1;
    if (nextIdx >= deck.length) {
      S.story = assign(st, {deck: deck, fast: fast, quick: 0});
      S.screen = 'end';
      render();
      track('b4s_story_complete', {fast: fast}, true);
      return;
    }
    S.story = assign(st, {deck: deck, fast: fast, quick: quick, idx: nextIdx, nonce: st.nonce + 1, seen: Math.max(st.seen, nextIdx + 1)});
    cardStartedAt = Date.now();
    render();
    trackCard();
  }

  function prev() {
    var st = S.story;
    cardStartedAt = Date.now();
    S.story = assign(st, {idx: Math.max(0, st.idx - 1), quick: 0, nonce: st.nonce + 1});
    render();
    trackCard();
  }

  function toFork() {
    S.holdPaused = false;
    S.autoDone = true;
    S.screen = 'fork';
    render();
  }

  function toOwn(from) {
    if (S.sending || S.uncertain) return;
    track('b4s_ready', {from: from, card: from === 'story' ? currentCard() : null, cards_seen: from === 'fork' ? 0 : S.story.seen}, true);
    S.pick = defaultPick;
    S.counts = freshCounts(defaultPick);
    S.touched = false;
    S.step = 1;
    S.error = null;
    S.holding = false;
    S.sending = false;
    S.readyHref = null;
    S.holdPaused = false;
    S.autoDone = true;
    S.screen = 'own';
    render();
    syncOwn();
  }

  function ownBack() {
    if (S.sending || S.uncertain) return;
    S.holding = false;
    S.error = null;
    S.readyHref = null;
    if (S.step > 1) {
      S.step -= 1;
      render();
      syncOwn();
    } else {
      S.screen = 'fork';
      render();
    }
  }

  function ownNext() {
    if (S.step === 1) track('b4s_finish', {finish: S.pick});
    if (S.step === 2) {
      if (!setTotal()) return;
      track('b4s_qty', {qty: setTotal(), finishes: setRows().length, mix: setRows().length > 1});
    }
    if (S.step < 3) {
      S.step += 1;
      render();
      syncOwn();
      var q = root.querySelector('.b4s-q');
      if (q) {
        q.setAttribute('tabindex', '-1');
        q.focus({preventScroll: true});
      }
    }
  }

  function summary() {
    var rows = setRows();
    var n = setTotal();
    if (!n) return '';
    if (n === 1) return 'Baton 4 · ' + rows[0].f.name + ' · ' + money(setPrice());
    var parts = rows.length === 1 ? rows[0].f.name : rows.map(function (r) { return r.n + ' ' + r.f.name; }).join(', ');
    return n + ' Baton 4s · ' + parts + ' · ' + money(setPrice());
  }

  /* ── checkout ── */

  function commit() {
    if (S.sending || S.uncertain || !hasCheckout) return;
    var rows = setRows();
    if (!rows.length) return;
    S.holding = false;
    S.sending = true;
    S.error = null;
    syncOwn();
    vibrate([16, 40, 24]);

    var want = {};
    rows.forEach(function (r) {
      want[r.f.id] = r.n;
    });
    track('b4s_checkout', {finishes: rows.map(function (r) { return r.n + '-' + r.f.slug; }).join('+'), qty: setTotal(), value: setPrice() / 100, currency: currency}, true);

    if (CFG.checkout === 'permalink') {
      var url = permalink(want);
      var win = null;
      try {
        win = window.open(url, '_blank', 'noopener');
      } catch (e) {
        win = null;
      }
      window.setTimeout(function () {
        S.sending = false;
        S.readyHref = url;
        syncOwn();
      }, 450);
      return;
    }

    ajaxCheckout(want)
      .then(function () {
        window.location.assign((CFG.checkoutPath || '/checkout'));
      })
      .catch(function (err) {
        S.sending = false;
        S.error = S.uncertain ? 'Your cart may have been updated. Review your cart before trying again.' : err && err.userMessage ? err.userMessage : 'Could not check current stock. Please try again.';
        syncOwn();
      });
  }

  /* Add only the selected quantities; never rewrite existing lines. */
  async function ajaxCheckout(want) {
    async function read(url, options) {
      var res = await fetch(url, assign({credentials: 'same-origin', cache: 'no-store'}, options || {}));
      var body = await res.json();
      if (!res.ok) {
        var error = cartError(body);
        error.rejected = true;
        throw error;
      }
      return body;
    }
    var fresh = await read((CFG.productUrl || '/products/' + product.handle) + '.js?b4s=' + Date.now());
    var ids = Object.keys(want);
    ids.forEach(function (id) {
      var v = (fresh.variants || []).find(function (x) { return String(x.id) === id; });
      var shown = finishes.find(function (x) { return String(x.id) === id; });
      if (!v || !v.available || !shown || v.price !== shown.price || !Number.isInteger(want[id]) || want[id] < 1 || want[id] > MAX_EACH) {
        var e = new Error('Product changed');
        e.userMessage = 'Price or availability changed. Reload this page to see current choices.';
        throw e;
      }
    });
    var cartUrl = CFG.cartRead || '/cart.js';
    var before = await read(cartUrl);
    function count(cart, id) {
      return (cart.items || []).reduce(function (n, item) { return String(item.variant_id) === String(id) ? n + item.quantity : n; }, 0);
    }
    S.uncertain = true;
    try { sessionStorage.setItem('b4s-pending', '1'); } catch (e) {}
    try {
      await read(CFG.cartAdd || '/cart/add.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({items: ids.map(function (id) { return {id: Number(id), quantity: want[id]}; })})
      });
    } catch (error) {
      if (error.rejected) {
        try {
          var rejectedCart = await read(cartUrl);
          if (JSON.stringify(rejectedCart.items) === JSON.stringify(before.items)) {
            S.uncertain = false;
            try { sessionStorage.removeItem('b4s-pending'); } catch (e) {}
          }
        } catch (e) {}
      }
      throw error;
    }
    var after = await read(cartUrl);
    ids.forEach(function (id) {
      if (count(after, id) !== count(before, id) + want[id]) throw new Error('Cart quantity could not be verified');
    });
    (before.items || []).forEach(function (item) {
      if (!ids.includes(String(item.variant_id)) && count(after, item.variant_id) !== count(before, item.variant_id)) throw new Error('Existing cart changed');
    });
    S.uncertain = false;
    try { sessionStorage.removeItem('b4s-pending'); } catch (e) {}
    return after;
  }

  function cartError(body) {
    var e = new Error('cart');
    var text = String((body && (body.description || body.message)) || '');
    e.userMessage = /sold out|not available|inventory|quantity|all \d+/i.test(text)
      ? 'We don’t have that many in one finish right now. Go back and lower the count, or mix in another finish.'
      : 'Checkout didn’t open. Hold again and we’ll retry.';
    return e;
  }

  function permalink(want) {
    var origin = CFG.storeOrigin || '';
    var items = Object.keys(want).map(function (id) {
      return id + ':' + want[id];
    });
    var q = 'attributes[_landing]=' + encodeURIComponent(CFG.landingId || 'baton4-story');
    var code = readCookie('discount_code');
    if (code) q += '&discount=' + encodeURIComponent(code);
    return origin + '/cart/' + items.join(',') + '?' + q;
  }

  /* ── wiring ── */

  function wireAuto() {
    var fill = root.querySelector('.b4s-auto-fill');
    if (!fill || fill.getAttribute('data-wired')) return;
    fill.setAttribute('data-wired', '1');
    fill.style.animationPlayState = S.hidden || S.sheetOpen ? 'paused' : 'running';
    fill.addEventListener('animationend', function (e) {
      if (e.animationName !== 'b4s-seg' || S.screen !== 'fork' || S.autoDone) return;
      startStory('auto');
    });
  }

  function wire() {
    wireAuto();
    var run = root.querySelector('.b4s-seg-fill.is-run');
    if (run) {
      run.addEventListener('animationend', function (e) {
        if (e.animationName !== 'b4s-seg') return;
        next(true);
      });
    }
    root.querySelectorAll('.b4s-tap').forEach(function (zone) {
      zone.addEventListener('pointerdown', onPressStart);
      zone.addEventListener('pointerup', onPressEnd);
      zone.addEventListener('pointerleave', onPressCancel);
      zone.addEventListener('pointercancel', onPressCancel);
      zone.addEventListener('contextmenu', noMenu);
      zone.addEventListener('click', function () {
        var wasHold = lastPress > LONG_PRESS_MS;
        lastPress = 0;
        if (wasHold) return;
        if (zone.classList.contains('b4s-tap-next')) next(false);
        else prev();
      });
    });
    var fork = root.querySelector('[data-zone="fork"]');
    if (fork) {
      fork.addEventListener('pointerdown', function (e) {
        forkY = e.clientY;
      });
      fork.addEventListener('pointerup', function (e) {
        if (forkY !== null && S.screen === 'fork' && !S.sheetOpen && forkY - e.clientY > 60) startStory('swipe');
        forkY = null;
      });
    }
    wireHold();
  }

  function wireHold() {
    var hold = root.querySelector('.b4s-hold');
    if (!hold) return;
    var top = hold.querySelector('.b4s-hold-top');
    hold.addEventListener('pointerdown', function () {
      if (S.sending) return;
      S.error = null;
      S.holding = true;
      hold.classList.add('is-holding');
      setHoldLabel(hold, 'Keep holding');
      var err = root.querySelector('.b4s-error');
      if (err) err.remove();
      vibrate(8);
    });
    var end = function () {
      if (!S.holding) return;
      S.holding = false;
      hold.classList.remove('is-holding');
      if (!S.sending) setHoldLabel(hold, 'Hold to make it yours');
    };
    hold.addEventListener('pointerup', end);
    hold.addEventListener('pointerleave', end);
    hold.addEventListener('pointercancel', end);
    hold.addEventListener('contextmenu', noMenu);
    hold.addEventListener('click', function (e) {
      // Keyboard presses arrive as clicks with no pointer behind them.
      if (e.detail === 0) commit();
    });
    if (top) {
      top.addEventListener('animationend', function (e) {
        if (e.animationName === 'b4s-hold' && S.holding) commit();
      });
    }
  }

  function setHoldLabel(hold, text) {
    hold.querySelectorAll('.b4s-hold-lbl').forEach(function (el) {
      el.textContent = text;
    });
  }

  function onPressStart() {
    downAt = Date.now();
    lastPress = 0;
    S.holdPaused = true;
    syncPause();
  }
  function onPressEnd() {
    lastPress = Date.now() - downAt;
    S.holdPaused = false;
    syncPause();
  }
  function onPressCancel() {
    if (!S.holdPaused) return;
    S.holdPaused = false;
    syncPause();
  }

  root.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-action]') : null;
    if (!el || !root.contains(el)) return;
    if (S.sending || S.uncertain) return;
    var a = el.getAttribute('data-action');
    var slug = el.getAttribute('data-finish');
    if (a === 'restock') document.getElementById('b4s-restock').showModal();
    else if (a === 'learn') startStory('tap');
    else if (a === 'replay') startStory('replay');
    else if (a === 'ready') toOwn(S.screen === 'end' ? 'end' : S.screen === 'story' ? 'story' : 'fork');
    else if (a === 'fork') toFork();
    else if (a === 'specs') openSheet(slug || (S.screen === 'own' ? S.pick : heroOne ? heroOne.slug : ''));
    else if (a === 'sheet-close') closeSheet();
    else if (a === 'sheet-finish') {
      S.sheetFinish = slug;
      refreshSheet();
    } else if (a === 'pick') {
      if (!bySlug[slug] || !bySlug[slug].available) return;
      S.pick = slug;
      if (!S.touched) S.counts = freshCounts(slug);
      else if (!S.counts[slug]) S.counts[slug] = 1;
      syncOwn();
    } else if (a === 'inc' || a === 'dec') {
      setCount(slug, (S.counts[slug] || 0) + (a === 'inc' ? 1 : -1));
      var same = root.querySelector('[data-action="' + a + '"][data-finish="' + slug + '"]');
      if (same && !same.disabled) same.focus();
      else {
        var field = root.querySelector('#b4s-count-' + slug);
        if (field) field.focus();
      }
    } else if (a === 'own-back') ownBack();
    else if (a === 'own-next') ownNext();
  });

  // Typing a count: digits only, applied as they type, tidied on leaving the field.
  root.addEventListener('input', function (e) {
    var el = e.target;
    if (!el.classList || !el.classList.contains('b4s-count')) return;
    var digits = el.value.replace(/[^0-9]/g, '').slice(0, 2);
    if (digits !== el.value) el.value = digits;
    if (digits === '') return;
    setCount(el.getAttribute('data-finish'), Number(digits));
  });
  root.addEventListener('focusout', function (e) {
    var el = e.target;
    if (!el.classList || !el.classList.contains('b4s-count')) return;
    var slug = el.getAttribute('data-finish');
    if (el.value === '') setCount(slug, 0);
    el.value = String(S.counts[slug] || 0);
  });
  root.addEventListener('focusin', function (e) {
    var el = e.target;
    if (el.classList && el.classList.contains('b4s-count')) {
      try {
        el.select();
      } catch (err) {}
    }
  });
  root.addEventListener('keydown', function (e) {
    var el = e.target;
    if (!el.classList || !el.classList.contains('b4s-count')) return;
    var slug = el.getAttribute('data-finish');
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();
      setCount(slug, (S.counts[slug] || 0) + (e.key === 'ArrowUp' ? 1 : -1));
      el.value = String(S.counts[slug] || 0);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      el.blur();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (S.sheetOpen) {
      var dialog = root.querySelector('.b4s-sheet');
      if (!dialog) return;
      if (e.key === 'Escape') {
        e.stopPropagation();
        closeSheet();
        return;
      }
      if (e.key !== 'Tab') return;
      // Tab stays inside the panel while it is open.
      var focusable = Array.prototype.slice.call(dialog.querySelectorAll('button, a[href]'));
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (!dialog.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
      return;
    }
    if (S.screen === 'story') {
      if (e.key === 'ArrowRight') next(false);
      else if (e.key === 'ArrowLeft') prev();
      else if (e.key === 'Escape') toFork();
    }
  });

  document.addEventListener('visibilitychange', function () {
    S.hidden = document.visibilityState === 'hidden';
    syncPause();
  });
  window.addEventListener('pageshow', function (e) {
    // Back from checkout: let them hold again.
    if (e.persisted && S.screen === 'own') {
      S.sending = false;
      S.holding = false;
      syncOwn();
    }
  });

  function trackCard() {
    if (S.screen !== 'story') return;
    track('b4s_card', {card: currentCard(), index: S.story.idx});
  }

  /* ═══════════════════════════════════════════
     HELPERS
     ═══════════════════════════════════════════ */

  /* Native Shopify pixels retain consent, standard events and CAPI ownership. */
  function track(event, data) {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (navigator.globalPrivacyControl === true || !cp || typeof cp.analyticsProcessingAllowed !== 'function' || !cp.analyticsProcessingAllowed()) return;
      if (window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(event, assign({page: CFG.landingId || 'baton4-story'}, data || {}));
      }
    } catch (e) {}
  }

  function parseFinish(p) {
    var raw = p.get('finish') || p.get('color') || p.get('colour') || p.get('flavor') || '';
    var vid = p.get('variant');
    if (vid) {
      var hit = (product.variants || []).filter(function (v) { return String(v.id) === String(vid); })[0];
      if (hit) raw = hit.option1 || hit.title;
    }
    var slug = slugify(raw);
    if (slug === 'blue') slug = 'regal-blue';
    if (slug === 'pilot') slug = 'fighter-pilot';
    if (slug === 'od-green' || slug === 'olive') slug = 'green';
    return slug || null;
  }

  function freshCounts(slug) {
    var out = {};
    if (slug && bySlug[slug] && bySlug[slug].available) out[slug] = 2;
    return out;
  }
  function countWord(n) {
    var words = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten'];
    return words[n] || String(n);
  }
  function andList(list) {
    if (list.length < 2) return list.join('');
    return list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1];
  }
  function slugify(s) {
    return String(s || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function rank(slug) {
    var i = ORDER.indexOf(slug);
    return i === -1 ? 99 : i;
  }
  function featuredSrc(v) {
    var m = v && (v.featured_image || (v.featured_media && v.featured_media.preview_image));
    return m && m.src ? m.src : '';
  }
  function altFor(f) {
    return 'Baton 4 in ' + f.name + ', docked in its open charging case';
  }
  function assign(a, b) {
    var out = {};
    var k;
    for (k in a) if (Object.prototype.hasOwnProperty.call(a, k)) out[k] = a[k];
    for (k in b) if (Object.prototype.hasOwnProperty.call(b, k)) out[k] = b[k];
    return out;
  }
  function seeded(i, n) {
    var x = Math.sin(i * 127.1 + n * 311.7) * 43758.5453;
    return x - Math.floor(x);
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
  function attr(s) {
    return esc(s).replace(/'/g, '&#39;');
  }
  function cssUrl(s) {
    return '&quot;' + String(s || '').replace(/["\\]/g, '') + '&quot;';
  }
  function readCookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) {
      return '';
    }
  }
  function noMenu(e) {
    e.preventDefault();
  }
  function vibrate(pattern) {
    try {
      if (navigator.vibrate) navigator.vibrate(pattern);
    } catch (e) {}
  }

  var PATHS = {
    right: '<path d="M5 12h14"/><path d="M13 6l6 6-6 6"/>',
    left: '<path d="M19 12H5"/><path d="M11 6l-6 6 6 6"/>',
    chevL: '<path d="M15 5l-7 7 7 7"/>',
    up: '<path d="M12 19V5"/><path d="M6 11l6-6 6 6"/>',
    close: '<path d="M6 6l12 12"/><path d="M18 6L6 18"/>',
    check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
    replay: '<path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/>',
    plus: '<path d="M12 5v14"/><path d="M5 12h14"/>',
    minus: '<path d="M5 12h14"/>',
    out: '<path d="M14 5h5v5"/><path d="M19 5l-8 8"/><path d="M18 14v5H5V6h5"/>'
  };
  function icon(name, size, stroke, cls) {
    return '<svg' + (cls ? ' class="' + cls + '"' : '') + ' width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + (stroke || 2) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + PATHS[name] + '</svg>';
  }

  /* ── boot ── */

  document.documentElement.classList.add('b4s-page');
  document.body.classList.add('b4s-page');
  try { S.uncertain = sessionStorage.getItem('b4s-pending') === '1'; } catch (e) {}
  if (S.uncertain) { S.screen = 'own'; S.step = 3; }
  render();
  track('b4s_view', {finish: asked || 'all'});
  // The countdown starts on the next frame, once everything above can react to it.
  window.requestAnimationFrame(function () {
    hydrated = true;
    if (S.screen === 'fork' && !S.autoDone) {
      var auto = root.querySelector('.b4s-auto');
      if (auto && !auto.firstChild) {
        auto.innerHTML = '<span class="b4s-auto-fill" style="--b4s-dur:' + AUTO_START_MS + 'ms"></span>';
        wireAuto();
      }
    }
  });
})();
